import { useMutation } from "react-query";
import { upsertDevelopmentalHistory } from "api/customers";
import { useGlobalToast } from "components/GlobalToastProvider";

export const useUpsertDevelopmentalHistory = (options: Record<string, any> = {}) => {
  const { onError = () => {}, ...otherOptions } = options;
  const { showToast } = useGlobalToast();

  const { mutate, isLoading, ...rest } = useMutation(
    ({ clientId, payload }: { clientId: number; payload: Record<string, any> }) =>
      upsertDevelopmentalHistory(clientId, payload),
    {
      onError: () => {
        showToast({
          message: "Whoops! Something went wrong while saving the developmental history.",
          errorState: true,
        });
        onError();
      },
      ...otherOptions,
    }
  );

  return {
    upsertDevelopmentalHistoryMutation: mutate,
    isUpsertDevelopmentalHistoryLoading: isLoading,
    ...rest,
  };
};

export default useUpsertDevelopmentalHistory;
